import React from 'react';
import Size from './Size';
const SizeS = ({ color, ...props }) => (React.createElement(Size, Object.assign({ color: color, size: 24 }, props)));
SizeS.displayName = 'SizeS'; // Fix for tsc
export default SizeS;
//# sourceMappingURL=SizeS.js.map